/** Deposit bonus tier copy — merged into non-English panel locales. */
export const panelDepositBonusByLang = {
  es: {
    'user.deposit.bonus.title': 'Bono por depósito',
    'user.deposit.bonus.subtitle':
      'Saldo extra en depósitos USDT y canjes de e-voucher que cumplan el mínimo.',
    'user.deposit.bonus.tierLine': '{{min}} o más → {{percent}}% extra',
    'user.deposit.bonus.preview': 'Depósito de {{amount}} → bono de {{bonus}}',
    'user.deposit.history.col.bonus': 'Bono',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'Cupón canjeado. {{amount}} + {{bonus}} de bono ({{percent}}%) añadidos.',
  },
  de: {
    'user.deposit.bonus.title': 'Einzahlungsbonus',
    'user.deposit.bonus.subtitle':
      'Extra-Guthaben bei qualifizierten USDT-Einzahlungen und E-Voucher-Einlösungen.',
    'user.deposit.bonus.tierLine': '{{min}} oder mehr → {{percent}}% extra',
    'user.deposit.bonus.preview': '{{amount}} Einzahlung → {{bonus}} Bonus',
    'user.deposit.history.col.bonus': 'Bonus',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'Gutschein eingelöst. {{amount}} + {{bonus}} Bonus ({{percent}}%) gutgeschrieben.',
  },
  fr: {
    'user.deposit.bonus.title': 'Bonus de dépôt',
    'user.deposit.bonus.subtitle':
      'Solde supplémentaire sur les dépôts USDT et échanges d’e-voucher éligibles.',
    'user.deposit.bonus.tierLine': '{{min}} ou plus → {{percent}}% en plus',
    'user.deposit.bonus.preview': 'Dépôt de {{amount}} → bonus de {{bonus}}',
    'user.deposit.history.col.bonus': 'Bonus',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'Bon échangé. {{amount}} + {{bonus}} de bonus ({{percent}}%) ajoutés.',
  },
  ar: {
    'user.deposit.bonus.title': 'مكافأة الإيداع',
    'user.deposit.bonus.subtitle':
      'رصيد إضافي على إيداعات USDT واسترداد القسائم الإلكترونية المؤهلة.',
    'user.deposit.bonus.tierLine': '{{min}} أو أكثر → {{percent}}% إضافية',
    'user.deposit.bonus.preview': 'إيداع {{amount}} → مكافأة {{bonus}}',
    'user.deposit.history.col.bonus': 'المكافأة',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'تم استرداد القسيمة. {{amount}} + {{bonus}} مكافأة ({{percent}}%) مضافة.',
  },
  ja: {
    'user.deposit.bonus.title': '入金ボーナス',
    'user.deposit.bonus.subtitle':
      '条件を満たすUSDT入金およびEバウチャー利用時に追加残高が付与されます。',
    'user.deposit.bonus.tierLine': '{{min}}以上 → {{percent}}% 追加',
    'user.deposit.bonus.preview': '{{amount}}の入金 → {{bonus}}のボーナス',
    'user.deposit.history.col.bonus': 'ボーナス',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'バウチャーを利用しました。{{amount}} + {{bonus}} ボーナス（{{percent}}%）が加算されました。',
  },
  ko: {
    'user.deposit.bonus.title': '입금 보너스',
    'user.deposit.bonus.subtitle':
      '조건을 충족하는 USDT 입금 및 E-바우처 사용 시 추가 잔액이 지급됩니다.',
    'user.deposit.bonus.tierLine': '{{min}} 이상 → {{percent}}% 추가',
    'user.deposit.bonus.preview': '{{amount}} 입금 → {{bonus}} 보너스',
    'user.deposit.history.col.bonus': '보너스',
    'user.deposit.voucher.toastRedeemedWithBonus':
      '바우처를 사용했습니다. {{amount}} + {{bonus}} 보너스 ({{percent}}%)가 추가되었습니다.',
  },
  'zh-CN': {
    'user.deposit.bonus.title': '存款奖励',
    'user.deposit.bonus.subtitle': '符合条件的 USDT 存款和电子券兑换可获得额外余额。',
    'user.deposit.bonus.tierLine': '{{min}} 及以上 → 额外 {{percent}}%',
    'user.deposit.bonus.preview': '{{amount}} 存款 → {{bonus}} 奖励',
    'user.deposit.history.col.bonus': '奖励',
    'user.deposit.voucher.toastRedeemedWithBonus':
      '券已兑换。已添加 {{amount}} + {{bonus}} 奖励（{{percent}}%）。',
  },
  pt: {
    'user.deposit.bonus.title': 'Bônus de depósito',
    'user.deposit.bonus.subtitle':
      'Saldo extra em depósitos USDT e resgates de e-voucher qualificados.',
    'user.deposit.bonus.tierLine': '{{min}} ou mais → {{percent}}% extra',
    'user.deposit.bonus.preview': 'Depósito de {{amount}} → bônus de {{bonus}}',
    'user.deposit.history.col.bonus': 'Bônus',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'Voucher resgatado. {{amount}} + {{bonus}} de bônus ({{percent}}%) adicionados.',
  },
  it: {
    'user.deposit.bonus.title': 'Bonus deposito',
    'user.deposit.bonus.subtitle':
      'Saldo extra su depositi USDT e riscatti e-voucher che soddisfano il minimo.',
    'user.deposit.bonus.tierLine': '{{min}} o più → {{percent}}% extra',
    'user.deposit.bonus.preview': 'Deposito {{amount}} → bonus {{bonus}}',
    'user.deposit.history.col.bonus': 'Bonus',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'Voucher riscattato. {{amount}} + {{bonus}} bonus ({{percent}}%) aggiunti.',
  },
  ru: {
    'user.deposit.bonus.title': 'Бонус за депозит',
    'user.deposit.bonus.subtitle':
      'Дополнительный баланс при квалифицированных депозитах USDT и погашении e-voucher.',
    'user.deposit.bonus.tierLine': '{{min}} и более → +{{percent}}%',
    'user.deposit.bonus.preview': 'Депозит {{amount}} → бонус {{bonus}}',
    'user.deposit.history.col.bonus': 'Бонус',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'Ваучер погашен. Добавлено {{amount}} + {{bonus}} бонус ({{percent}}%).',
  },
  bn: {
    'user.deposit.bonus.title': 'জমা বোনাস',
    'user.deposit.bonus.subtitle':
      'যোগ্য USDT জমা এবং ই-ভাউচার রিডিমে অতিরিক্ত ব্যালেন্স।',
    'user.deposit.bonus.tierLine': '{{min}} বা বেশি → {{percent}}% অতিরিক্ত',
    'user.deposit.bonus.preview': '{{amount}} জমা → {{bonus}} বোনাস',
    'user.deposit.history.col.bonus': 'বোনাস',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'ভাউচার রিডিম হয়েছে। {{amount}} + {{bonus}} বোনাস ({{percent}}%) যোগ হয়েছে।',
  },
  hi: {
    'user.deposit.bonus.title': 'जमा बोनस',
    'user.deposit.bonus.subtitle':
      'योग्य USDT जमा और ई-वाउचर रिडीम पर अतिरिक्त बैलेंस।',
    'user.deposit.bonus.tierLine': '{{min}} या अधिक → {{percent}}% अतिरिक्त',
    'user.deposit.bonus.preview': '{{amount}} जमा → {{bonus}} बोनस',
    'user.deposit.history.col.bonus': 'बोनस',
    'user.deposit.voucher.toastRedeemedWithBonus':
      'वाउचर रिडीम हुआ। {{amount}} + {{bonus}} बोनस ({{percent}}%) जोड़ा गया।',
  },
};
